var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H5C2.25 0 0 2.10938 0 4.6875V45.3125C0 47.8906 2.25 50 5 50H45C47.75 50 50 47.8906 50 45.3125V4.6875C50 2.10938 47.75 0 45 0ZM43.3333 43.75H6.66667V6.25H43.3333V43.75ZM13.3333 28.125H36.6667V31.25H13.3333V28.125ZM13.3333 34.375H36.6667V37.5H13.3333V34.375ZM16.6667 14.0625C16.6669 13.4467 16.7965 12.837 17.048 12.2682C17.2996 11.6994 17.6682 11.1826 18.1328 10.7473C18.5974 10.312 19.1489 9.96679 19.7558 9.73134C20.3627 9.49588 21.0132 9.37479 21.67 9.375C22.3268 9.37521 22.9772 9.49669 23.5839 9.73253C24.1907 9.96837 24.7419 10.3139 25.2062 10.7495C25.6705 11.1851 26.0388 11.7021 26.2899 12.2711C26.5411 12.8401 26.6702 13.4498 26.67 14.0656C26.6696 15.3092 26.1422 16.5018 25.2039 17.3808C24.2656 18.2599 22.9932 18.7535 21.6667 18.7531C20.3401 18.7527 19.0681 18.2583 18.1304 17.3786C17.1928 16.499 16.6662 15.3061 16.6667 14.0625ZM25 18.75H18.3333C15.5833 18.75 13.3333 20.1562 13.3333 21.875V25H30V21.875C30 20.1562 27.75 18.75 25 18.75Z",
    fill: "#1A5ECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.ad25fcf8a19565edb226ed327e7397fb.svg";
export { ForwardRef as ReactComponent };